<template>
	<div class="main">
		<div class="top-panel">
			<div class="search-pane">
				<div class="search-item-box">
					<a-select size="small" style="width: 200px"></a-select>
				</div>
				<div class="search-item-box">
					<a-select size="small" style="width: 200px"></a-select>
				</div>
				<div class="search-item-box">
					<a-select size="small" style="width: 200px"></a-select>
				</div>
			</div>
			<div class="btn">
				<div class="search-item-box">
					<a-button type="primary" ghost size="small">查询</a-button>
				</div>
				<div class="search-item-box">
					<a-button type="default" class="reset-btn" size="small">重置</a-button>
				</div>
			</div>
		</div>
		<div class="table-box">
			<a-table :columns="columns" :data-source="data">
				<template #action>
					<a>删除</a>
				</template>
			</a-table>
		</div>
	</div>
</template>

<script>
export default {
	name: "FireMonitoring",
	data() {
		return {
			columns: [
				{title: 'Name', dataIndex: 'name', key: 'name'},
				{title: 'Age', dataIndex: 'age', key: 'age'},
				{title: 'Address', dataIndex: 'address', key: 'address'},
				{title: 'Action', dataIndex: '', key: 'x', scopedSlots: {customRender: 'action'}},
			],
			data: [
				{
					key: 1,
					name: 'John Brown',
					age: 32,
					address: 'New York No. 1 Lake Park',
					description: 'My name is John Brown, I am 32 years old, living in New York No. 1 Lake Park.',
				},
				{
					key: 2,
					name: 'Jim Green',
					age: 42,
					address: 'London No. 1 Lake Park',
					description: 'My name is Jim Green, I am 42 years old, living in London No. 1 Lake Park.',
				},
				{
					key: 3,
					name: 'Joe Black',
					age: 32,
					address: 'Sidney No. 1 Lake Park',
					description: 'My name is Joe Black, I am 32 years old, living in Sidney No. 1 Lake Park.',
				},
			]
		}
	}
}
</script>

<style lang="less">
</style>
